/**
 * Checks the given event object whether the event actually contains conditions to allow for item activation
 * 	e.g. a valid click event or a keypress event through the enter (13) or space (32) key
 *
 * @param event activation event
 */
export function isActuallyActivated(event): boolean {
	if (event.type === 'click') {
		return true;
	}

	if (event.type === 'keypress' || event.type === 'keydown') {
		const code = event.charCode || event.keyCode;

		return code === 13 || code === 32;
	}

	return false;
}

interface WhenActuallyActivatedOptions {
	preventDefault?: boolean;
	stopPropagation?: boolean;
}

export function whenActuallyActivated(
	event: Event,
	callback: (event: Event) => void,
	options: WhenActuallyActivatedOptions = {},
): void {
	if (!isActuallyActivated(event)) return;

	const { preventDefault = true, stopPropagation = true } = options;

	if (preventDefault) {
		event.preventDefault();
	}
	if (stopPropagation) {
		event.stopPropagation();
	}

	callback(event);
}
